import React from 'react';
import PropTypes from 'prop-types';
import OutOfStock from './notification/out_of_stock';
import LowStock from './notification/low_stock';
import AlternativeStock from './notification/alternative_stock';
import Translation from '../../translation/translation';

function Notification(props) {
    let component;
    const { productType } = props;
    const httpRequestProductBatchStocks = props.httpRequestProductBatchStocks;

    if (props.stock === 0) {
        component = <OutOfStock onNotifyMeClick={props.onNotifyMeClick} />;
    } else if (props.stock < 10) {
        if (true === httpRequestProductBatchStocks.started
            && false === httpRequestProductBatchStocks.success
            && false === httpRequestProductBatchStocks.failed) {
            return (
                <div className='alternative-product-stock'>
                    <Translation
                        className="alternative-product-stock__loading"
                        translationKey={'product-tile-product-batch-stocks-loading'}
                        tagName={'div'} />
                </div>
            );
        } else if (true === httpRequestProductBatchStocks.success
            && true === haveAlternativeStock(props.productBatchStocks, props.stock)) {
            component = <AlternativeStock
                stock={props.stock}
                sku={props.sku}
                price={props.price}
                productBatchStocks={props.productBatchStocks}
                onAlternativeProductStockClick={props.onAlternativeProductStockClick}
            />;
        } else {
            if (props.stock < 5) {
                component = <LowStock stock={props.stock}
                    onNotifyMeClick={props.onNotifyMeClick}
                    productType={productType} />;
            } else {
                return null;
            }
        }
    } else {
        return null;
    }

    return (
        <div className="product-tile__product-notification">
            {component}
        </div>
    );
}

function haveAlternativeStock(alternativeStock, currentStockQuantity) {
    if (null === alternativeStock
        || typeof alternativeStock.statusCode === 'undefined'
        || 200 !== alternativeStock.statusCode) return false;

    const mixedStockQuantity = alternativeStock.body.mixedStocksAvailableQuantity;
    return (mixedStockQuantity > 0 && mixedStockQuantity > currentStockQuantity);
}

Notification.propTypes = {
    stock: PropTypes.number.isRequired,
    onNotifyMeClick: PropTypes.func.isRequired,
    productBatchStocks: PropTypes.object,
    sku: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    httpRequestProductBatchStocks: PropTypes.shape({
        started: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        failed: PropTypes.bool.isRequired,

    }),
    onAlternativeProductStockClick: PropTypes.func.isRequired,
};

export default Notification;
